import { StyleSheet } from 'react-native';

import { widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    button: {
        width: widthPercentageToDP(30),
        aspectRatio: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
});

export default styles;
